export enum APP_STATUS {
  idle = "idle",
  active = "active",
  paused = "paused"
}
